export default "__VITE_ASSET__CHnoE1HX__"